export default __webpack_public_path__ + "static/4-bb7764f3727a53ecaf8f5561e1eca519.png";